import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { MdSubscriptions, MdEventAvailable } from "react-icons/md";
import { FormInstance } from "antd";
import {
  AppDispatch,
  dynamicSet,
  Kit,
} from "@src/redux";
import { useDispatch } from "react-redux";
import { useCheckPageComponentAccess } from "@src/hooks/index";
import dayjs from "dayjs";

type Props = {
  kit: Kit;
  getKitLists: any;
  form: FormInstance;
};

const getValidityVariant = (date: any): "expired" | "warning" | "active" => {
  if (!date) return "expired";
  const now = moment();
  const till = moment(date);
  if (till.isBefore(now)) return "expired";
  if (till.diff(now, "days") <= 30) return "warning";
  return "active";
};

const ClientKitCardFooter: React.FC<Props> = ({ kit, form }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const variant = getValidityVariant(kit?.effectiveTill);

  const showModal = () => {
    dispatch(dynamicSet("subscription_plan_modal", { modal: true }));
    dispatch(dynamicSet("set_kit", { kit: kit }));
    form.setFieldsValue({
      effectiveFrom: kit?.effectiveFrom ? dayjs(kit?.effectiveFrom) : null,
      subscriptionId: kit?.subscriptionPlan?.id,
      remark: kit.remark,
    });
  };

  return (
    <div className="client-kit-card-footer-container">
      <div className={`kit-validity-strip kit-validity-strip--${variant}`}>
        <div className="kit-validity-icon-wrap">
          <MdEventAvailable size={20} />
        </div>
        <div className="kit-validity-text">
          <span className="kit-validity-label">{t("valid_till")}</span>
          <span className="kit-validity-date">
            {kit.effectiveTill
              ? moment(kit.effectiveTill).format("DD-MMM-YYYY")
              : "-"}
          </span>
        </div>
        {useCheckPageComponentAccess("client_kit_subscription_action") && (
          <button
            type="button"
            className="kit-validity-action-btn"
            aria-label="Manage subscription"
            onClick={showModal}
          >
            <MdSubscriptions size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ClientKitCardFooter;
